import { mpEventInfo } from '@/constant'
import type { DefaultResponse, Pagination } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 학생 API
const studentApi = {
  // 기기 - 학생앱 설정 가져오기
  getStudentsAppSetting() {
    return maxios.get<DefaultResponse<res.StudentAppSetting[]>>(`/students/app-setting`, {
      params: { mp_event_name: mpEventInfo.학생앱설정조회 },
    })
  },
  // 기기 - 학생앱 설정 변경하기
  putStudentsAppSetting(data: req.StudentAppSetting[]) {
    return maxios.put('/students/app-setting', data, {
      params: { mp_event_name: mpEventInfo.학생앱설정수정 },
    })
  },
  // 학생 생성하기
  postVirtualStudent(data: req.CreateStudent) {
    return maxios.post('/students', data, {
      params: { mp_event_name: mpEventInfo.가상학생등록 },
    })
  },
  // 학생 생성하기
  postStudents(data: req.CreateStudent) {
    return maxios.post('/students', data, {
      params: { mp_event_name: mpEventInfo.학생등록 },
    })
  },
  // 학생 일괄등록 (엑셀 업로드)
  postStudentsXLS(params: req.StudentStatusParams, data: req.StudentXLS) {
    return maxios.post<DefaultResponse<res.PostStudentXLS>>('/students/xls', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { ...params, mp_event_name: mpEventInfo.학생일괄등록 },
    })
  },
  // 학생 가져오기
  getStudents(pageQueryString: string, filterOptions?: req.StudentFilterOptions) {
    return maxios.get<Pagination<res.Student[]>>(`/students${pageQueryString}`, {
      params: { ...filterOptions, mp_event_name: mpEventInfo.학생조회 },
    })
  },
  // 출석번호 새로 발급받기
  getAttendanceCode() {
    return maxios.get<DefaultResponse<string>>('/students/attendance-code', {
      params: { mp_event_name: mpEventInfo.학생출결번호재발급 },
    })
  },
  // 특정 학생 가져오기
  getStudentDetailById(id: req.StudentId) {
    return maxios.get<DefaultResponse<res.StudentDetail>>(`/students/${id}`, {
      params: { mp_event_name: mpEventInfo.특정학생조회 },
    })
  },
  // 해당 Id를 가진 학생 목록 가져오기(not paged)
  getStudentsById(ids: req.StudentId[]) {
    return maxios.get<DefaultResponse<res.Student[]>>(`/students/list`, {
      params: { idList: ids.join(','), mp_event_name: mpEventInfo.여러학생조회 },
    })
  },
  // 학생 일괄등록 엑셀 양식을 다운로드
  getStudentsXLS() {
    return maxios.get<Blob>('/students/xls', {
      responseType: 'blob',
      params: { mp_event_name: mpEventInfo.학생일괄등록양식다운로드 },
    })
  },
  // 특정학생 변경하기
  putStudentById(id: req.StudentId, data: req.ChangeStudent) {
    return maxios.put(`/students/${id}`, data, {
      params: { mp_event_name: mpEventInfo.특정학생수정 },
    })
  },
  // 특정 학생 상태변경하기
  patchStudentActive(data: req.StudentPatchFilterOption) {
    return maxios.patch(`/students`, data, {
      params: { mp_event_name: mpEventInfo.여러학생수정 },
    })
  },
  patchStudentInactive(data: req.StudentPatchFilterOption) {
    return maxios.patch(`/students`, data, {
      params: { mp_event_name: mpEventInfo.여러학생수정 },
    })
  },
  // 학생들 삭제하기
  deleteStudents(data: req.StudentDeleteFilterOption) {
    return maxios({
      url: '/students',
      method: 'DELETE',
      data,
      params: { mp_event_name: mpEventInfo.여러학생삭제 },
    })
  },

  // 전체 학생 삭제
  deleteAllStudents(payload: req.StudentDeleteFilterOption) {
    return maxios.post('/students/delete-all', payload, {
      params: { mp_event_name: mpEventInfo.학생전체삭제 },
    })
  },

  // 학년 정렬로 학생들 출결 가져오기
  // 학년 정렬로 학생들 출결 가져오기
  getStudentAttendance(queryString: string) {
    return maxios.get<DefaultResponse<res.StudentIncludeAttendance[]>>(
      `/students/attendance${queryString}`,
      {
        params: { mp_event_name: mpEventInfo.학생출결번호재발급 },
      },
    )
  },
  // 학년 정렬로 학생들 번호 가져오기
  getStudentPhone() {
    return maxios.get<DefaultResponse<res.StudentIncludePhone[]>>('/students/phone', {
      params: { mp_event_name: mpEventInfo.출결관리_학년별보기_특정학생출결정보조회 },
    })
  },

  // 학생 목록 일괄 다운로드
  getAllStudentsListXLS(queryString: string) {
    return maxios.get<Blob>(`/students/download/xls${queryString}`, {
      responseType: 'blob',
    })
  },
}

export default studentApi
